import localStorage from "local-storage-fallback";

import { ROLE_ACCESS, ROLE_NAMES } from "src/consts/role";
import { SANDBOX_ROUTES, VERIFICATION_ROUTES } from "src/consts/routes";
import history from "src/helpers/browser-history";
import { getSafely } from "src/helpers/object";
import privateRoutes from "src/routes/private-routes";
import publicRoutes from "src/routes/public-routes";

const roleLabel = "bf-role";
const USER_ALLOWED = "allowed";
const USER_NOT_ALLOWED = "not-allowed";
const USER_PENDING = "pending";

export function saveUserRole(role) {
  return localStorage.setItem(roleLabel, role);
}

export function loadUserRole() {
  const storageRole = localStorage.getItem(roleLabel);
  return isValidRole(storageRole) ? storageRole : "";
}

export function removeUserRole() {
  localStorage.removeItem(roleLabel);
}

export function isValidRole(role) {
  return Object.values(ROLE_NAMES).includes(role);
}

export function forwardNotAllowed() {
  history.push(publicRoutes.notFound.path);
}

export function isAllowedRoute(path) {
  return ROLE_ACCESS[loadUserRole()].includes(path);
}

export function checkAllowedStatus(user, match) {
  if (!user || Object.keys(user).length === 0) {
    return USER_PENDING;
  }

  const userRole = getSafely(["actions_rule", "message"], user);
  const currentPath = match.path;
  return ROLE_ACCESS[userRole].includes(currentPath) ? USER_ALLOWED : USER_NOT_ALLOWED;
}

export function doRoleAction(user, match, callback) {
  const status = checkAllowedStatus(user, match);

  if (status === USER_ALLOWED) {
    callback();
  } else if (status === USER_NOT_ALLOWED) {
    forwardNotAllowed();
  } else {
    return;
  }
}

/**
 * This function is to guard routes for user that has not verified yet (email verified + phone verified)
 * @param {*} user
 */
export function userVerifiedGuard(user, isOwner) {
  if (!Object.keys(user).length) return;

  const isEmailVerified = user?.current_user?.email_verified;
  const isPhoneVerified = user?.current_user?.phone_number_verified;
  const isUserVerified = isEmailVerified && isPhoneVerified;
  const role = user?.actions_rule?.message;

  ROLE_ACCESS[role].forEach((path) => {
    // user (ADMIN and DEVELOPER) can browse the sandbox routes if they already have email verified
    if (isEmailVerified && SANDBOX_ROUTES.includes(path)) {
      return;
    }

    if (isOwner && history.location.pathname === privateRoutes.home.path) {
      if (!isEmailVerified) {
        return history.push(privateRoutes.verificationEmail.path);
      }
      if (!isPhoneVerified) {
        return history.push(privateRoutes.verificationPhone.path);
      }
    }

    if (isOwner && !isUserVerified && !VERIFICATION_ROUTES.includes(path) && history.location.pathname === path) {
      forwardNotAllowed();
      return;
    }

    if (!isOwner && !isEmailVerified && history.location.pathname === path) {
      forwardNotAllowed();
    }
  });
}
